<template>
  <div class="container">
    <div v-show="loading" class="loading">正在加载中，请耐心等待...</div>
    <div v-show="!loading" class="well" ref="output"></div>
  </div>
</template>

<script>
import { getExtend, readBuffer, render } from './components/util'
import { parse } from 'qs'
import axios from 'axios'

/**
 * 支持嵌入式显示，基于postMessage支持跨域
 * 示例代码：
 *
 */
export default {
  name: 'Preview',
  props: {
    filePath: String
  },
  data() {
    return {
      // 加载状态跟踪
      loading: false,
      // 上个渲染实例
      last: null,
      // 隐藏头部，当基于消息机制渲染，将隐藏
      hidden: false,
      // 使用输入框
      input: false,
      // 浮层显示
      overlay: true,
      // 文件名
      filename: ''
    }
  },
  watch: {
    url: {
      handler() {
        if (this.filePath) {
          this.loadFromUrl(this.filePath)
        }
      },
      immediate: true
    }
  },
  created() {
    // 允许使用预留的消息机制发送二进制数据，必须在url后添加?name=xxx.xxx&from=xxx
    const { from, name } = parse(location.search.substr(1))
    if (from) {
      window.addEventListener('message', event => {
        const { origin, data: blob } = event
        if (origin === from && blob instanceof Blob) {
          // 构造响应，自动渲染
          const file = new File([blob], name, {});
          this.hidden = true;
          this.handleChange({ target: { files: [file] } });
        }
      })
    }
  },
  methods: {
    // 从url加载
    loadFromUrl(url) {
      this.loading = true;
      // 要预览的文件地址
      const filename = url.substr(url.lastIndexOf('/') + 1);
      // 拼接iframe请求url
      axios({
        url,
        method: 'get',
        responseType: 'blob',
      }).then(({ data }) => {
        if (!data) {
          console.error('文件下载失败');
        }
        const file = new File([data], filename, {});
        this.handleChange({ target: { files: [file] } });
      }).finally(() => {
        this.loading = false;
      })
    },
    async handleChange(e) {
      this.loading = true;
      try {
        const [file] = e.target.files;
        this.filename = file.name && decodeURIComponent(file.name) || '';
        const arrayBuffer = await readBuffer(file);
        this.loading = false
        this.last = await this.displayResult(arrayBuffer, file)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    displayResult(buffer, file) {
      // 取得文件名
      const { name } = file;
      // 取得扩展名
      const extend = getExtend(name);
      // 输出目的地
      const { output } = this.$refs;
      // 生成新的dom
      const node = document.createElement('div');
      // 添加孩子，防止vue实例替换dom元素
      if (this.last) {
        output.removeChild(this.last.$el);
        this.last.$destroy();
      }
      const child = output.appendChild(node);
      // 调用渲染方法进行渲染
      return new Promise((resolve, reject) => render(buffer, extend, child)
        .then(resolve).catch(reject));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.well {
  display: block;
  background-color: #f2f2f2;
  border: 1px solid #ccc;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.loading {
  height: fit-content;
}
</style>

<style>
.pptx-wrapper {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
